import type { ComponentType } from 'react';
import { ProcessingModesGuide } from './ProcessingModesGuide';
import { ResultsGuide } from './ResultsGuide';
import { WebhooksGuide } from './WebhooksGuide';
import { ErrorsGuide } from './ErrorsGuide';
import { LimitsGuide } from './LimitsGuide';
import { ChangelogGuide } from './ChangelogGuide';

/** One guide under /developers/<slug>; the quickstart is /developers itself, the reference /developers/reference. */
export interface Guide {
  slug: string;
  title: string;
  /** One line for the navigation's hover and the page's lead. */
  summary: string;
  Page: ComponentType;
}

export const guides: readonly Guide[] = [
  {
    slug: 'processing-modes',
    title: 'Processing modes',
    summary: 'How Paige reads a job’s documents, and what waits for a person.',
    Page: ProcessingModesGuide,
  },
  {
    slug: 'results',
    title: 'Results and exports',
    summary: 'Documents, fields, evidence, table rows, the PDF, and where results go.',
    Page: ResultsGuide,
  },
  {
    slug: 'webhooks',
    title: 'Webhooks',
    summary: 'Each confirmed document posted to your endpoint, signed.',
    Page: WebhooksGuide,
  },
  {
    slug: 'errors',
    title: 'Errors and retries',
    summary: 'Problem details, stable codes, and which calls to retry.',
    Page: ErrorsGuide,
  },
  {
    slug: 'limits',
    title: 'Limits and versions',
    summary: 'The rate limit, upload sizes, pages, and how the API changes.',
    Page: LimitsGuide,
  },
  {
    slug: 'changelog',
    title: 'Changelog',
    summary: 'What changed in the API, newest first.',
    Page: ChangelogGuide,
  },
];

export function guideOf(slug: string): Guide | undefined {
  return guides.find((g) => g.slug === slug);
}
